import './assets/App.css';
import LakeChart from "./chart/LakeChart";
import Header from "./header/Header";
import InfoSection from "./infoSection/InfoSection";
import ContextCommon from "./context/ContextCommon";

function App() {

    return (
        <div className="App">
            <ContextCommon>
                <Header />

                <LakeChart />

                <InfoSection />
            </ContextCommon>
        </div>
    );
}

export default App;
